<template>
    <div>
        <action-bar>
        </action-bar>
        <main class="content">
            <div v-if="resumee">
                <h1>Programm Resümee bearbeiten<br>
                    <small class="text-muted">{{resumee.name.text}}</small>
                </h1>
                <text-input :value="resumee.name" label="Name" ref="name"></text-input>
                <long-text-input :value="resumee.description" label="Header Text" ref="description"></long-text-input>
                <long-text-input :value="resumee.longDescription" label="Beschreibungstext der auf der Programmseite angezeigt wird" ref="longDescription"></long-text-input>
                <!--<long-text-input :value="resumee.longDescription" label="" ref="longDescription"></long-text-input> -->
                <text-input :value="resumee.fileDownloadTitle" label="PDF Title" ref="fileDownloadTitle"></text-input>
                <file-input v-model="file" label="Programm Resümee PDF" type="file"></file-input>
                <file-input v-model="fileImage" label="Image for the PDF Download" type="image"></file-input>

                <file-input v-model="images" label="Bilder" type="image" :max-files="12"></file-input>
                <div class="admin-info mb-3">
                    <p>
                      Das erste Bild wird als Titelbild verwendet, die anderen Bilder werden auf der Programm-Seite als weitere
                      Bilder in dem Slider verwendet
                    </p>
                </div>
                <hr>
                <button class="btn btn-primary" @click="save">Save</button>
            </div>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {
      resumee: this.data,
      images: this.data.images.slice(),
      file: this.data.file,
      fileImage: this.data.fileImage
    };
  },
  watch: {
    data(newData) {
      this.resumee = newData;
      this.images = newData.images.slice();
    }
  },
  methods: {
    saveResumee() {
      let form = new FormData();
      for(let i = 0; i < this.images.length; i++) {
        const image = this.images[i];

        if (image && image.id) {
          form.append("edit_program_resumee[images][" + i + "]", image.id);
        }
      }
      if (this.file && this.file.id) {
        form.append("edit_program_resumee[file]", this.file.id);
      } else {
        form.append("edit_program_resumee[file]", "");
      }
      if (this.fileImage && this.fileImage.id) {
        form.append("edit_program_resumee[fileImage]", this.fileImage.id);
      } else {
        form.append("edit_program_resumee[fileImage]", "");
      }
      return axios.post(
        "/api/" +
          store.state.language +
          "/program_resumee/" +
          this.resumee.id +
          "/edit",
        form
      ).then(({ data }) => {
          this.resumee = data.result;
          this.images = data.result.images;
          this.fileImage = data.result.fileImage;
          this.file = data.result.file;
      });
    },
    save() {
      store.commit("addSavingProcess");
      Promise.all([
        this.$refs.name.save(),
        this.$refs.description.save(),
        this.$refs.longDescription.save(),
        this.$refs.fileDownloadTitle.save(),
        this.saveResumee()
      ]).then(() => {
        store.commit("finishSavingProcess");
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/program_resumee/General.vue